export default __webpack_public_path__ + "static/media/balance1.6d4141e0.svg";